import { render, staticRenderFns } from "./ShockIndex.vue?vue&type=template&id=b0f65e10&scoped=true&"
import script from "./ShockIndex.vue?vue&type=script&lang=js&"
export * from "./ShockIndex.vue?vue&type=script&lang=js&"
import style0 from "./ShockIndex.vue?vue&type=style&index=0&id=b0f65e10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f65e10",
  null
  
)

export default component.exports